import { render, staticRenderFns } from "./dowload-app-tips.vue?vue&type=template&id=090a6fe8&scoped=true&"
import script from "./dowload-app-tips.vue?vue&type=script&lang=js&"
export * from "./dowload-app-tips.vue?vue&type=script&lang=js&"
import style0 from "./dowload-app-tips.vue?vue&type=style&index=0&id=090a6fe8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090a6fe8",
  null
  
)

export default component.exports